import { appealPlatMap, rightFileExtType, fileExtType } from '../../const'

export { rightFileExtType, fileExtType }

export const exportConfig = Object.freeze([
  {
    key: 'subApplicationOrder',
    label: '申诉子单号',
  },
  {
    key: 'pkId',
    label: '匹配结果ID',
  },
  {
    key: 'complaintTrackList.tracklistId',
    label: '申诉歌单ID',
  },
  {
    key: 'companyList',
    label: '授权方信息',
    format: (val) => (val || []).map(s => s.companyName).join('、')
  },
  {
    key: 'complaintTrackList.trackName',
    label: '投诉内容-作品名称',
  },
  {
    key: 'complaintTrackList.albumName',
    label: '投诉内容-专辑名',
  },
  {
    key: 'complaintTrackList.singerName',
    label: '投诉内容-歌手名',
  },
  {
    key: 'complaintTrackList.srcVersion',
    label: '投诉内容-版本',
  },
  {
    key: 'complaintTrackList.appealPlat',
    label: '投诉内容-平台',
    format: (val) => appealPlatMap[val]
  },
  {
    key: 'complaintTrackList.appealUrl',
    label: '投诉内容-作品链接',
  },
  {
    key: 'complaintTrackList.originTrackName',
    label: '原作品-作品名称',
  },
  {
    key: 'complaintTrackList.originAlbumName',
    label: '原作品-专辑名',
  },
  {
    key: 'complaintTrackList.originSingerName',
    label: '原作品-歌手名',
  },
  {
    key: 'complaintTrackList.originSrcVersion',
    label: '原作品-版本',
  },
  {
    key: 'complaintTrackList.originWordAuthor',
    label: '原作品-词作者',
  },
  {
    key: 'complaintTrackList.originMusicAuthor',
    label: '原作品-曲作者',
  },
  {
    key: 'rightFile',
    label: '权利文件名(需跟作品名称保持一致，含后缀)',
    width: 40,
    empty: true
  },
  {
    key: 'action',
    label: '操作',
    empty: true
  },
])
